export default __webpack_public_path__ + "static/media/thumbnail.1e967e25.png";